import { DeepMap } from 'react-hook-form';
import { JobsiteUpdateInput } from 'apollo/generated/client-operations';
import { ensureNonUndefinedFields, titleToKebabCase } from 'utils';
import { FormInputTypes, TypedFormInputs } from 'components/form';
import { EditJobsiteConfigurationFormData } from 'containers/jobsiteConfiguration/types';
import { Jobsite } from './types';
import {
  getOnboardingSectionDefaultValues,
  getOnboardingSectionUpdateInput,
  onboardingSectionInputs,
} from './onboardingSection';

export type EditJobsiteConfigTabFormData = Pick<
  EditJobsiteConfigurationFormData,
  'onboarding'
>;

export const getFormInputs =
  (): TypedFormInputs<EditJobsiteConfigTabFormData> => {
    return {
      onboarding: {
        element: FormInputTypes.Section,
        layout: '',
        elementProps: {
          title: 'Onboarding',
          details: 'Set top-level rules for onboarding',
          verticalGap: 'sm',
        },
        children: onboardingSectionInputs,
      },
    };
  };

type GetDefaultValuesArgs = {
  jobsite: Jobsite;
};

export const getDefaultValues = (
  args: GetDefaultValuesArgs,
): EditJobsiteConfigTabFormData => {
  const { jobsite } = args;
  const onboarding = getOnboardingSectionDefaultValues(jobsite);
  return { onboarding };
};

const getOnboardingModuleInput = (
  jobsite: Jobsite,
  data: EditJobsiteConfigTabFormData,
  dirtyFields: DeepMap<EditJobsiteConfigTabFormData, true>,
): JobsiteUpdateInput['onboardingModule'] => {
  const onboardingSectionUpdateInput = getOnboardingSectionUpdateInput(
    data.onboarding,
    dirtyFields.onboarding,
    {},
  );

  const steps = onboardingSectionUpdateInput?.steps.filter(Boolean);
  const hasChanged = Boolean(steps?.length);

  return hasChanged
    ? {
        name: `${jobsite.name} - onboarding`,
        slug: `${titleToKebabCase(jobsite.name)}-onboarding`,
        isEnabled: true,
        steps,
      }
    : undefined;
};

export const getJobsiteUpdateInput = (
  jobsite: Jobsite,
  data: EditJobsiteConfigTabFormData,
  dirtyFields: DeepMap<EditJobsiteConfigTabFormData, true>,
): JobsiteUpdateInput => {
  return ensureNonUndefinedFields<JobsiteUpdateInput>({
    jobsiteId: jobsite.jobsiteId,
    onboardingModule: getOnboardingModuleInput(jobsite, data, dirtyFields),
  });
};
